
/* ===== VELANTIS_CC — páginas Aceites / Difusores ===== */
(function(){
  function route(){
    var hs=location.hash||'';
    var isA=/^#\/aceites\/?$/.test(hs), isD=/^#\/difusores\/?$/.test(hs);
    document.body.classList.toggle('aceites',isA);
    document.body.classList.toggle('difusores',isD);
    var a=document.getElementById('aceitesPage'); if(a)a.hidden=!isA;
    var d=document.getElementById('difusoresPage'); if(d)d.hidden=!isD;
    if(isA||isD) window.scrollTo(0,0);
  }
  window.addEventListener('hashchange',route);
  if(document.readyState!=='loading') route(); else document.addEventListener('DOMContentLoaded',route);
})();
